import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "@core/services/configuration.service";
import * as moment from "moment";
import { Observable } from "rxjs";
import {
	DashBoardFilterFormValue
} from "src/app/layout/dashboard/services/dashboard-filter-form-builder.service";
import {DashBoardAllStatistics, DashBoardDetailInformation} from "@helper/types/dashboard";

export class Dashboards {

	public get$(filter: DashBoardFilterFormValue): Observable<DashBoardAllStatistics> {
		const url = `${this.config.api.root}/statistic/get_statistic`;
		const types = ["DAY", "WEEK", "MONTH", "YEAR"];
		const body = {
			dateFrom: moment(filter.period[0]).format("DD.MM.yyyy"),
			dateTo: moment(filter.period[1]).format("DD.MM.yyyy"),
			serviceCode: filter.service,
			detailType:	types[filter.detailsType],
		};
		return this.http.post<DashBoardAllStatistics>(url, body, { withCredentials: true });
	}

	public getDetailClaim$(filter: DashBoardFilterFormValue, dateTo: string): Observable<DashBoardDetailInformation> {
		const url = `${this.config.api.root}/statistic/get_statistic_detail`;
		const body = {
			dateFrom: moment(filter.period[0]).format("DD.MM.yyyy"),
			dateTo: dateTo || moment(filter.period[1]).format("DD.MM.yyyy"),
			serviceCode: filter.service,
			detailType:	"CS",
		};
		return this.http.post<DashBoardDetailInformation>(url, body, { withCredentials: true });
	}

	public getDetailPayment$(filter: DashBoardFilterFormValue, dateTo: string): Observable<DashBoardDetailInformation> {
		const url = `${this.config.api.root}/statistic/get_statistic_detail`;
		const body = {
			dateFrom: moment(filter.period[0]).format("DD.MM.yyyy"),
			dateTo: dateTo || moment(filter.period[1]).format("DD.MM.yyyy"),
			serviceCode: filter.service,
			detailType:	"PS",
		};
		return this.http.post<DashBoardDetailInformation>(url, body, { withCredentials: true });
	}

	public getDetailTypeOfDevices$(filter: DashBoardFilterFormValue, dateTo: string): Observable<DashBoardDetailInformation> {
		const url = `${this.config.api.root}/statistic/get_statistic_detail`;
		const body = {
			dateFrom: moment(filter.period[0]).format("DD.MM.yyyy"),
			dateTo: dateTo || moment(filter.period[1]).format("DD.MM.yyyy"),
			serviceCode: filter.service,
			detailType:	"PD",
		};
		return this.http.post<DashBoardDetailInformation>(url, body, { withCredentials: true });
	}


	constructor(private config: ConfigurationService, private http: HttpClient) { }
}
